import { configureApi } from '@scc/lib'
import { useSessionStore } from '@/lib/session.store'

// On refresh failure, clear the one session (auth-unification U2) — the
// caller (use-session-bootstrap's subscription, or a portal component's own
// 401 handler) is responsible for routing to /login.
configureApi({
  baseUrl: import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:3001/api/v1',
  getToken: () => useSessionStore.getState().token,
  setToken: (t) => useSessionStore.getState().setToken(t),
  onAuthFailure: () => useSessionStore.getState().clearSession(),
})
